import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { usePartyActingPersonParty } from "Hooks/useUserActingPersonParty";

export const useCurrentUserActingPersonParty = () => {
  const user = useLoggedInUser();

  return usePartyActingPersonParty(user?.partyPublicID);
};
